import React, { useState } from "react";

import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Rating,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";

import {
  Facebook,
  FlashOn,
  ShoppingCart,
  Twitter,
  WhatsApp,
} from "@mui/icons-material";
import { BasicCard, HeaderComp } from "components";
import { Reviews } from "pages";
import { useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterMoment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { useIsMounted } from "hooks";
import { onValue, ref, set } from "firebase/database";
import { database } from "configs/firebaseConfigs";
import {
  useCartData,
  useProducts,
  useSuppliers,
  useWishlistData,
} from "hooks/useDataFetch";
import { useAppContext } from "contexts";
import Lottie from "react-lottie";
import { notFound } from "asset/animations";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";

const ProductDetails = () => {
  const [productDetails, setProductDetails] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [inCart, setInCart] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [deliveryTime, setDeliveryTime] = useState([]);
  const [chooseDeliveryTime, setChooseDeliveryTime] = useState(" ");

  const cartData = useCartData();
  const { user } = useAppContext();

  const navigate = useNavigate();

  const { id } = useParams();

  const isMounted = useIsMounted();
  const supplier = useSuppliers();

  //check if product is in cart

  useEffect(() => {
    if (isMounted.current) {
      let exist = cartData?.data?.some((item) => {
        return item?.id === id;
      });

      if (exist) {
        setInCart(true);
      }
    }
  }, [cartData, isMounted, id]);

  //decrease quantity

  const decrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    } else {
      setQuantity(1);
    }
  };

  //get product data

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, `products/${id}`), (snapshot) => {
        if (snapshot.exists()) {
          // console.log(snapshot.val());
          setProductDetails(snapshot.val());
        } else {
          navigate("/");
        }
      });
    }
  }, [id, isMounted, navigate]);

  // console.log(id);

  // console.log(productDetails);

  /////////////////////////tab-nav/////////////////////////////////
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index } = props;

    return (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && <div>{children}</div>}
      </div>
    );
  }

  function allProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,

      className: `${
        tabValue === index && "product-details-full-description-nav-tab-active"
      }`,
    };
  }

  //////////////////////////////////////mosque checked////////////////////////////////

  const [donateMosque, setDonateMosque] = useState(false);

  // console.log(donateMosque);

  //////////supplier settings/////////////

  const supplierSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [pickupDate, setPickupDate] = useState(null);

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, "/config/deliverytime"), (snap) => {
        if (snap.exists()) {
          setDeliveryTime(snap.val());
        }
      });
    }
  }, [isMounted]);

  // console.log(deliveryTime);

  const addToCart = () => {
    try {
      if (!user.uid) {
        Swal.fire({
          title: "Please login to add to cart",
          icon: "warning",
        });
        return;
      }
      if (inCart) {
        // Swal.fire({
        //   title: "Already in cart",
        //   icon: "info",
        // });
        navigate("/cart");

        return;
      }
      const cartData = {
        id: id,
        quantity: quantity,
        createdAt: Date.now(),
      };
      // console.log(cartData);

      //check if item already in cart

      set(ref(database, `cart/${user?.uid}/${id}`), cartData)
        .then(() => {
          Swal.fire({
            title: "Added to cart",
            icon: "success",
          });
        })
        .catch((error) => {
          // console.log(error);
          Swal.fire({
            title: "Something Went Wrong. Try Again!",
            icon: "error",
          });
        });
    } catch (error) {
      // console.log(error);
      Swal.fire({
        title: "Something Went Wrong. Try Again!",
        icon: "error",
      });
    }
  };

  let imageSlide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
  };

  // console.log(window.location.pathname);

  const handleBuy = () => {
    if (!user.uid) {
      return navigate(`/login?redirect=${window.location.pathname}`);
    }
    const orderData = {
      products: [
        {
          id: id,
          quantity: quantity,
        },
      ],
      deliveryDate: pickupDate,
      deliveryTime: chooseDeliveryTime,
    };

    if (donateMosque) {
      navigate("/mosque", { state: { orderData } });
    } else {
      navigate("/cart/checkout", { state: { orderData } });
    }
  };

  console.log(chooseDeliveryTime);

  return (
    <>
      <main>
        <header>
          <HeaderComp title="PRODUCT DETAILS" />
        </header>
        <section className="product-details-section">
          <Container>
            <div className="product-details-container">
              <div className="product-details-content flex-row w-100 gap-2 ">
                <div className="product-details-img-section flex-column gap-2 ">
                  <div className="product-details-img-section-main-image">
                    {productDetails?.images?.length && (
                      <img
                        src={productDetails?.images[activeImage]?.url}
                        alt="Product Details"
                      />
                    )}
                  </div>

                  <div className="product-details-slider-outer">
                    {/* <span className="product-image-details-container flex-row gap-2 "> */}
                    <Slider {...imageSlide}>
                      {productDetails?.images?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="product-details-slider-inner"
                          >
                            <span
                              onClick={() => {
                                console.log(index);
                                setActiveImage(index);
                              }}
                            >
                              <img src={item?.url} alt="Product Details" />
                            </span>
                          </div>
                        );
                      })}
                    </Slider>
                    {/* </span> */}

                    {/* <span className="product-details-images-btn flex-row align-items-center justify-content-between w-100">
                      <Button>
                        <ChevronLeft />
                      </Button>
                      <Button>
                        <ChevronRight />
                      </Button>
                    </span> */}
                  </div>
                </div>

                <div className="product-details-details-section flex-column gap-2 ">
                  <div className="product-details-header-section flex-column gap-2 ">
                    <div className="product-details-header-title">
                      <h3 className="product-supplier-name">
                        {productDetails?.name}
                      </h3>

                      <h3 className="product-model-details">
                        {productDetails?.title}
                      </h3>
                    </div>

                    <span className="product-details-header-rating">
                      <Rating
                        name="read-only"
                        value={productDetails?.rating || 0}
                        readOnly
                      />
                    </span>

                    <span className="product-details-header-review flex-row align-items-center gap-2 ">
                      <span className="product-details-header-review-count">
                        Interested In : {productDetails.interestedIn}
                      </span>

                      <span className="product-details-header-review-count">
                        {productDetails?.reviews} Reviews.
                      </span>
                    </span>
                  </div>
                  <hr />

                  <div className="product-details-desc-section flex-column gap-2 ">
                    <div className="product-details-share-section flex-row align-items-center gap-2 ">
                      Share :{" "}
                      <span className="product-details-desc-section-social flex-row align-items-center gap-1 ">
                        <span className="flex-row align-items-center">
                          <a
                            href={`https://www.facebook.com/sharer/sharer.php?u=${window?.location?.href}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Facebook />
                          </a>
                        </span>

                        <span className="flex-row align-items-center">
                          <a
                            href={`https://twitter.com/intent/tweet?url=${window?.location?.href}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Twitter />
                          </a>
                        </span>

                        {/* <span className="flex-row align-items-center">
                          <Instagram />
                        </span> */}

                        <span className="flex-row align-items-center">
                          <a
                            href={`https://api.whatsapp.com/send?phone=&text=${window?.location?.href}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <WhatsApp />
                          </a>
                        </span>
                      </span>
                    </div>

                    <div className="product-details-desc-price flex-row align-items-center gap-1 ">
                      <span className="product-details-new-price">
                        SAR {productDetails?.price}{" "}
                      </span>
                      <span className="product-details-old-price">
                        SAR{" "}
                        {(
                          (productDetails?.price *
                            (100 + productDetails?.discount)) /
                          100
                        ).toFixed(2)}
                      </span>
                      <span className="product-details-discount">
                        {productDetails?.discount}% off
                      </span>
                    </div>

                    <div className="product-details-short-description">
                      <h6>Short Description:</h6>
                      {ReactHtmlParser(productDetails?.shortDesc)}
                    </div>

                    <div className="product-details-cart flex-column gap-2 ">
                      <div className="product-details-cart-availability flex-row gap-2 align-items-center ">
                        <span className="flex-row align-items-center gap-1">
                          Qty :{" "}
                          <span className="product-quantity-box flex-row justify-content-between">
                            <Button onClick={decrease}> - </Button>
                            <span>{quantity}</span>
                            <Button
                              onClick={() => {
                                setQuantity(quantity + 1);
                              }}
                            >
                              +
                            </Button>
                          </span>
                        </span>
                        <span>
                          Availability :{" "}
                          <span className="product-details-cart-availability-span">
                            {productDetails?.quantity > 0
                              ? "In Stock"
                              : "Out of Stock"}
                          </span>
                        </span>
                      </div>

                      <div className="product-details-donate-to-mosque-btn flex-row align-items-center justify-content-between">
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Donate to mosque"
                            onClick={() => {
                              setDonateMosque(!donateMosque);
                            }}
                          />
                        </FormGroup>
                      </div>

                      <div className="delivery-time-select flex-row align-items-center gap-1 ">
                        <div className="product-select-delivery-date">
                          <LocalizationProvider dateAdapter={DateAdapter}>
                            <DatePicker
                              label="Select Delivery Date"
                              value={pickupDate}
                              disablePast
                              onChange={(newValue) => {
                                setPickupDate(
                                  moment(newValue).format("YYYY-MM-DD")
                                );
                              }}
                              toolbarPlaceholder="Select Delivery  Date"
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                        <div className="delivery-time-picker">
                          <Select
                            className="product-select-delivery-time"
                            value={chooseDeliveryTime}
                            onChange={(e) => {
                              setChooseDeliveryTime(e.target.value);
                            }}
                          >
                            <MenuItem value={" "}>Select Time</MenuItem>
                            {deliveryTime?.map((time, index) => {
                              return (
                                <MenuItem value={time} key={index}>
                                  {" "}
                                  {time.startTime} - {time.endTime}{" "}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </div>
                      </div>

                      <div className="product-details-add-to-cart flex-row gap-1 ">
                        <Button
                          startIcon={<ShoppingCart />}
                          onClick={addToCart}
                        >
                          {inCart ? "Go to Cart" : "Add to Cart"}
                        </Button>

                        {/* <Link to={donateMosque ? "/donate" : "/cart/checkout"}> */}
                        <Button startIcon={<FlashOn />} onClick={handleBuy}>
                          Buy Now
                        </Button>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="product-details-full-description flex-column ">
                <div className="product-details-full-description-nav">
                  <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    className="flex-row gap-1"
                  >
                    <Tab
                      label="Description"
                      className="product-details-full-description-nav-tab"
                      {...allProps(0)}
                    />
                    <Tab
                      label="Related Products"
                      className="product-details-full-description-nav-tab"
                      {...allProps(1)}
                    />
                    <Tab
                      label="Reviews"
                      className="product-details-full-description-nav-tab"
                      {...allProps(2)}
                    />
                  </Tabs>
                  <TabPanel value={tabValue} index={0}>
                    <ProductDesc data={productDetails?.description} />
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    <RelatedProducts
                      supplierId={productDetails?.supplierId}
                      productId={id}
                    />
                  </TabPanel>
                  <TabPanel value={tabValue} index={2}>
                    <section className="product-details-tab-review">
                      <Reviews id={id} title={productDetails?.name} />
                    </section>
                  </TabPanel>
                </div>
              </div>

              {/* mobile view */}

              <div className="responsive-description">
                <div className="responsive-product-desc">
                  <h1 className="responsive-product-details-title">
                    Description
                  </h1>
                  <div className="responsive-product-desc-content">
                    <ProductDesc data={productDetails?.description} />
                  </div>
                </div>
                <div className="responsive-product-review">
                  <div className="responsive-product-review-content">
                    <Reviews id={productDetails?.id} />
                  </div>
                </div>
                <div className="responsive-product-related">
                  <h1 className="responsive-product-details-title">
                    Related Products
                  </h1>
                  <div className="responsive-product-related-content">
                    <RelatedProducts
                      supplierId={productDetails?.supplierId}
                      productId={productDetails?.id}
                    />
                  </div>
                </div>
              </div>

              {supplier && supplier?.data && (
                <div className="business-partners">
                  <div className="business-partners-heading flex-column align-items-center ">
                    <h1 className="business-partners-heading-h1">
                      Our Suppliers
                    </h1>

                    <p className="business-partners-heading-p">
                      Nunc molestie mi nunc, nec accumsan libero dignissim sit
                      amet. Fusce sit amet tincidunt metus. Nunc eu risus
                      suscipit massa dapibus blandit. Vivamus ac commodo eros.
                    </p>
                  </div>

                  <div className="supplier-slider">
                    <Slider {...supplierSettings}>
                      {supplier &&
                        supplier?.data &&
                        supplier?.data?.map((item, index) => {
                          return (
                            <div key={index}>
                              <div className="business-partner-outer flex-row justify-content-center align-items-center ">
                                <img
                                  src={item?.image}
                                  alt="Business Partners"
                                />
                              </div>
                            </div>
                          );
                        })}
                    </Slider>
                  </div>
                </div>
              )}
            </div>
          </Container>
        </section>
      </main>
    </>
  );
};

export default ProductDetails;

const ProductDesc = (props) => {
  return (
    <div className="responsive-product-description">
      <div className="product-details-full-description-section flex-column ">
        <span className="product-details-full-description-section-span">
          {ReactHtmlParser(props?.data)}
        </span>
      </div>
    </div>
  );
};

const RelatedProducts = ({ supplierId, productId }) => {
  const product = useProducts();
  const isMounted = useIsMounted();
  const [relatedProducts, setRelatedProducts] = useState([]);
  const wishList = useWishlistData();

  const cartData = useCartData();

  useEffect(() => {
    if (isMounted.current) {
      const relatedProducts = product?.data?.filter(
        (item) => item.supplierId === supplierId && item.id !== productId
      );
      setRelatedProducts(relatedProducts);
    }
  }, [product?.data, isMounted, supplierId, productId]);
  // console.log(relatedProducts);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: notFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      // className="product-details-related-product-section  "
      spacing={2}
    >
      {relatedProducts && relatedProducts?.length > 0 ? (
        relatedProducts?.map((item, index) => {
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              // className="flex-row justify-content-center related-product-section-grid flex-wrap"
              key={index}
            >
              <div className="flex-row align-items-center justify-content-center">
                <BasicCard
                  inWishlist={
                    wishList?.data?.some((data) => {
                      return data?.id === item?.id;
                    }) || false
                  }
                  inCart={
                    cartData?.data?.some((data) => {
                      return data?.id === item?.id;
                    }) || false
                  }
                  data={item}
                />
              </div>
            </Grid>
          );
        })
      ) : (
        <div className="w-100 flex-row align-items-center justify-content-center ">
          <Lottie height={300} options={notFoundLottie} width={300} />
        </div>
      )}
    </Grid>
  );
};
